module.exports = __webpack_public_path__ + "static/media/slider4.2a48c79c.jpg";